import Config from '../../config'

export const getDatasetList = (host: string, token: string) => {
    const reqestURL = `${host}/${Config.version}/vallaris/datasets`;
    const reqestHeader: HeadersInit = new Headers();
    reqestHeader.set("Content-Type", "application/json");
    reqestHeader.set("Authorization", `Bearer ${token}`);

    return fetch(reqestURL, {
        method: "GET",
        headers: reqestHeader
    })
        .then(response => response.json())
        .then(response => {
            if (response.status.code === 200) {
                return response.data ? Array.isArray(response.data) ? response.data : [response.data] : new Array();
            } else {
                return response;
            }
        })
        .catch((error: any) => error);
}

export const getLayerList = (host: string, token: string) => {
    const reqestURL = `${host}/${Config.version}/vallaris/layers`;
    const reqestHeader: HeadersInit = new Headers();
    reqestHeader.set("Content-Type", "application/json");
    reqestHeader.set("Authorization", `Bearer ${token}`);

    return fetch(reqestURL, {
        method: "GET",
        headers: reqestHeader
    })
        .then(response => response.json())
        .then(response => {
            if (response.status.code === 200) {
                return response.data ? Array.isArray(response.data) ? response.data : [response.data] : new Array();
            } else {
                return response;
            }
        })
        .catch((error: any) => error);
}

export const getRequestsList = (host: string, token: string, layerId: number | string) => {
    const reqestURL = `${host}/${Config.version}/vallaris/requests?layer_id=${layerId}`;
    const reqestHeader: HeadersInit = new Headers();
    reqestHeader.set("Content-Type", "application/json");
    reqestHeader.set("Authorization", `Bearer ${token}`);

    return fetch(reqestURL, {
        method: "GET",
        headers: reqestHeader
    })
        .then(response => response.json())
        .then(response => {
            if (response.status.code === 200) {
                return response.data ? Array.isArray(response.data) ? response.data : [response.data] : new Array();
            } else {
                return response;
            }
        })
        .catch((error: any) => error);
}